module.exports = __webpack_public_path__ + "img/immense_experience.7364ed67.svg";